
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privateWebsite",
      function () {
        return require("private-next-pages/privateWebsite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privateWebsite"])
      });
    }
  